import { Info, Rocket } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { TOOLTIP_DELAY_DURATION } from '@/lib/constants';

const WhyQuench = () => (
  <TooltipProvider>
    <Tooltip delayDuration={TOOLTIP_DELAY_DURATION}>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          tabIndex={-1}
          className="p-0 h-auto bg-transparent border-none hover:bg-transparent"
          childrenClassName="flex items-center justify-start gap-1"
        >
          <Info size={16} strokeWidth={1} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground font-normal">Why Quench?</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        align="start"
        sideOffset={8}
        className="max-w-[500px] p-4"
        avoidCollisions
      >
        <div className="flex flex-col gap-4">
          <div className="p-2 bg-muted rounded-lg">
            <p className="text-xs text-muted-foreground font-light leading-relaxed">
              Quenching is a rapid cooling process where hot metal is quickly cooled by immersion in
              water, oil, or air to achieve desired material properties. This process prevents
              unwanted crystallization and creates a harder, stronger final product.
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex gap-1 items-center">
              <Rocket size={20} strokeWidth={1.5} className="text-blue-600" />
              <p className="text-base font-medium text-blue-600">Anthos QUENCH</p>
            </div>
            <p className="text-sm font-normal text-muted-foreground leading-normal">
              A focused tool for rapidly processing contact records to achieve a desired data state,
              transforming raw/incomplete contact information into hardened, properly categorized
              data through quick, systematic updates.
            </p>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export { WhyQuench };
